import React, { useState } from "react";
import { toast } from "sonner";
import { MapPin, Phone, Mail, Clock, Instagram } from "lucide-react";

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - will be connected to backend later
    console.log("Contact Form:", formData);
    toast.success("Thank you for reaching out! We'll get back to you soon.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: ""
    });
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-[50vh] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1673201230274-c4dbd20c3f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwYXRlbGllcnxlbnwwfHx8fDE3NzI0NjUxMTJ8MA&ixlib=rb-4.1.0&q=85"
          alt="Contact MIA Atelier"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div className="max-w-3xl text-white">
            <h1 className="text-6xl md:text-7xl mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Get in Touch
            </h1>
            <p className="text-xl tracking-wider">
              We'd love to hear from you
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="py-24 px-6 bg-[#FAF9F7]">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Information */}
            <div>
              <h2 className="text-4xl mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
                Visit Our Atelier
              </h2>
              <p className="text-[#8B7D6B] leading-relaxed mb-12" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Whether you're ready to begin your order or would like to explore our collections, we welcome you to connect with the MIA Atelier.
              </p>
              <p className="text-[#8B7D6B] leading-relaxed mb-12" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Private consultations are available by appointment.
              </p>

              <div className="space-y-8">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4B5A0] flex items-center justify-center">
                    <MapPin className="text-white" size={20} />
                  </div>
                  <div>
                    <h3 className="text-xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                      Location
                    </h3>
                    <p className="text-[#8B7D6B]">
                      Abuja, Nigeria
                    </p>
                    <p className="text-[#A39383] text-sm mt-2 font-light" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      By Appointment Only
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4B5A0] flex items-center justify-center">
                    <Phone className="text-white" size={20} />
                  </div>
                  <div>
                    <h3 className="text-xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                      WhatsApp
                    </h3>
                    <p className="text-[#8B7D6B]">
                      +234 803 214 3826
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4B5A0] flex items-center justify-center">
                    <Mail className="text-white" size={20} />
                  </div>
                  <div>
                    <h3 className="text-xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                      Email
                    </h3>
                    <p className="text-[#8B7D6B]">
                      hello@miaatelier.co
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4B5A0] flex items-center justify-center">
                    <Clock className="text-white" size={20} />
                  </div>
                  <div>
                    <h3 className="text-xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                      Hours
                    </h3>
                    <p className="text-[#8B7D6B]">
                      Monday - Friday: 10:00 AM - 6:00 PM<br />
                      Saturday: 11:00 AM - 4:00 PM<br />
                      Sunday: By Appointment Only
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#C4B5A0] flex items-center justify-center">
                    <Instagram className="text-white" size={20} />
                  </div>
                  <div>
                    <h3 className="text-xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                      Instagram
                    </h3>
                    <a 
                      href="https://instagram.com/miaatelier.co" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#8B7D6B] hover:text-[#2C2C2C] transition-colors duration-300"
                    >
                      @miaatelier.co
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-white rounded-lg shadow-lg">
                <h3 className="text-2xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Book a Consultation
                </h3>
                <p className="text-[#8B7D6B] mb-4">
                  Private consultations are available by appointment. We recommend booking at least 
                  2 weeks in advance.
                </p>
                <button className="px-8 py-3 bg-[#C4B5A0] text-[#2C2C2C] tracking-wider font-medium hover:bg-[#D4C4B0] transition-colors rounded">
                  SCHEDULE APPOINTMENT
                </button>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white p-8 md:p-12 rounded-lg shadow-xl">
              <h2 className="text-4xl mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                Send a Message
              </h2>
              <p className="text-[#8B7D6B] mb-8">
                Have a question? Fill out the form below and we'll get back to you shortly.
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                    FULL NAME *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                    placeholder="Your name"
                  />
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                      EMAIL ADDRESS *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                      placeholder="your@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                      PHONE NUMBER
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                      placeholder="+234 XXX XXX XXXX"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                    SUBJECT *
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                    placeholder="What is this regarding?"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                    MESSAGE *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors resize-none"
                    placeholder="Tell us how we can help you..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full px-8 py-4 bg-[#C4B5A0] text-[#2C2C2C] tracking-widest font-medium hover:bg-[#D4C4B0] transition-all duration-300 rounded shadow-lg"
                >
                  SEND MESSAGE
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="h-96 bg-[#D4C4B0] flex items-center justify-center">
        <div className="text-center">
          <MapPin className="mx-auto mb-4 text-[#6B4E37]" size={48} />
          <p className="text-[#2C2C2C] text-lg">Map integration placeholder</p>
          <p className="text-[#6B4E37] text-sm">Abuja, Nigeria</p>
        </div>
      </section>
    </div>
  );
};
